<script setup>
import { vElementVisibility } from '@vueuse/components';
import { computed, ref, useTemplateRef, watch } from 'vue'
import NumberAnimation from 'vue-number-animation'

const NumberRef = useTemplateRef('AnimationNumber')

const props = defineProps({
  targetNumber: String,
  isPercent: {
    type: String,
    default: false
  }
})

const duration = 5
const isVisible = ref(false)

const onElementVisibility = (state) => {
  isVisible.value = state
}

watch(isVisible, (value) => {
  value ? NumberRef.value.play() : NumberRef.value.pause()
})

const isPercent = computed(() => {
  return props.isPercent == 'true' ? true : false
})

const targetNumber = computed(() => {
  return Number(props.targetNumber)
})

const format = (value) => {
  return value.toFixed(0)
}

</script>


<template>
  <div
    class="number-animation-helper flex flex-row ~text-4xl/6xl mb-5 text-white"
    v-element-visibility="onElementVisibility"
  >
    <NumberAnimation
      ref="AnimationNumber"
      :from="1"
      :format="format"
      :to="targetNumber"
      :duration="duration"
      animationPaused
    />
    <span class="ml-2" v-if="isPercent">%</span>
  </div>
</template>

<style lang="scss">

</style>
